var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSearch = function SvgSearch(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 10,
    "data-width-16": 13,
    "data-width-20": 17,
    "data-width-24": 20,
    "data-width-28": 23,
    "data-width-72": 59,
    viewBox: "0 0 23 23",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.441 18.317a10 10 0 0 0 5.553 1.693 10 10 0 0 0 6.43-2.343l4.828 4.828a.86.86 0 0 0 .618.256.86.86 0 0 0 .619-.256.875.875 0 0 0 0-1.237L17.66 16.43a10.01 10.01 0 0 0-.586-13.5 10.01 10.01 0 0 0-14.151 0A10.01 10.01 0 0 0 4.44 18.317m11.494-2.594a8.246 8.246 0 0 0-.108-11.557 8.248 8.248 0 1 0-.11 11.774.9.9 0 0 1 .218-.216",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export default ForwardRef;